import { RankingBarChart } from './RankingBarChart';
import type { NameValueItem } from './types';

type ApplicationsPendingStartChartProps = {
  data: NameValueItem[];
  loading?: boolean;
  title?: string;
};

export const ApplicationsPendingStartChart = ({
  data,
  loading = false,
  title = 'SOLICITUDES POR INICIAR POR CONVENIO',
}: ApplicationsPendingStartChartProps) => (
  <RankingBarChart title={title} data={data} loading={loading} />
);
